<!--
* @Description:相关调研2(代码替换时候要注意，样式与BI里面不一下需要注意)
* @Date: 2024-01-19 15:33:01
-->
<template>
  <div
    class="patient-sex"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="content" ref="ContentRef">
      <div class="content-warp">
        <div
          class="content-warp-item"
          v-for="(item, index) in _dataArr.tipData"
          :key="index"
          :style="{
            '--left': `${index + 1 == 1 ? '188px' : 'none'}`,
            '--right': `${index + 1 == 2 ? '188px' : 'none'}`
          }"
        >
          <div class="content-warp-item-box">
            <div
              v-for="(item2, index2) in item"
              :key="index2"
              class="content-warp-item-box-r"
              :style="{
                '--colors': `var(--theme-color-${item2[item2.length - 1]},#000)`
              }"
              ref="tipDom"
            >
              <div class="content-warp-item-box-bg"></div>
              <div class="content-warp-item-box-text">
                <div>
                  <div
                    v-for="(item3, index3) in item2.slice(0, item2.length - 1)"
                    :key="index3"
                  >
                    {{ item3.label }}：{{ item3.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-warp-circle-box">
          <div class="content-warp-circle-box-white"></div>
          <div class="content-warp-circle-box-border"></div>
          <div class="content-warp-circle-box-icon1">
            <baseSvg style="position: absolute; z-index: 1"></baseSvg>
            <div style="position: absolute">
              <svg2></svg2>
            </div>
          </div>
          <div
            v-for="(item2, index2) in _dataArr.tipData"
            :key="index2"
            class="content-warp-circle"
            :style="{
              '--rotate': `${index2 + 1 == 1 ? '-92' : '89'}deg`
            }"
          >
            <div
              :id="`circle-${index2 + 1}`"
              v-for="(item3, index3) in item2"
              :key="index3"
              class="content-warp-circle-item"
              :style="{
                '--color': `var(--theme-color-${item3[item3.length - 1]},#000)`
              }"
            >
              <div class="content-warp-circle-item-r"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-name">
        <div>
          <div
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            v-for="(item, index) in _dataArr.projectName"
            :key="index"
          >
            <div></div>
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { baseSvg, svg2 } from './svg-components/index';
import { ref, onMounted } from 'vue';
import { selfAdaption, useDataAssembly } from './hooks';
const props = defineProps<{
  tableHeaderList: Array<{ label: Array<string>; prop: string }>;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
let tipDom = ref(null);

let _dataArr = useDataAssembly(
  props.tableHeaderList,
  props.tableDataList,
  true
);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  const leftDom = TaskRef.value.querySelectorAll(
    '#circle-1'
  ) as NodeListOf<HTMLDivElement>;
  const rightDom = TaskRef.value.querySelectorAll(
    '#circle-2'
  ) as NodeListOf<HTMLDivElement>;
  if (leftDom.length + rightDom.length == 6) {
    leftDom[0].style.transform = `rotate(${45}deg)`;
    leftDom[1].style.transform = `rotate(${2}deg)`;
    leftDom[2].style.transform = `rotate(${-41}deg)`;
    rightDom[0].style.transform = `rotate(${-40}deg)`;
    rightDom[1].style.transform = `rotate(${3}deg)`;
    rightDom[2].style.transform = `rotate(${46}deg)`;
  }
  if (leftDom.length + rightDom.length == 5) {
    leftDom[0].style.transform = `rotate(${45}deg)`;
    leftDom[1].style.transform = `rotate(${2}deg)`;
    leftDom[2].style.transform = `rotate(${-41}deg)`;
    rightDom[0].style.transform = `rotate(${-18}deg)`;
    rightDom[1].style.transform = `rotate(${23}deg)`;
  }
  if (leftDom.length + rightDom.length == 4) {
    leftDom[0].style.transform = `rotate(${23}deg)`;
    leftDom[1].style.transform = `rotate(${-18}deg)`;
    rightDom[0].style.transform = `rotate(${-18}deg)`;
    rightDom[1].style.transform = `rotate(${23}deg)`;
  }
  if (leftDom.length + rightDom.length == 3) {
    leftDom[0].style.transform = `rotate(${22}deg)`;
    leftDom[1].style.transform = `rotate(${-18}deg)`;
    rightDom[0].style.transform = `rotate(${3}deg)`;
  }
  if (leftDom.length + rightDom.length == 2) {
    leftDom[0].style.transform = `rotate(${2}deg)`;
    rightDom[0].style.transform = `rotate(${3}deg)`;
  }
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.patient-sex {
  @include patientSex();
  .content {
    @include content();
    .content-warp {
      margin: 0 auto;
      margin-top: 100px;
      width: 900px;
      height: 366px;
      display: flex;
      justify-content: space-between;
      position: relative;
      .content-warp-item {
        width: 190px;
        height: 100%;
        .content-warp-item-box {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;

          .content-warp-item-box-r {
            margin: calc(7px / 2) 0;
            position: relative;
            width: 190px;
            height: 117px;
            .content-warp-item-box-bg {
              position: absolute;
              opacity: $--opacityText;
              width: 190px;
              height: 117px;
              background: var(--colors);
              border-radius: 12px;
            }
            .content-warp-item-box-text {
              position: absolute;
              border: 2px solid var(--colors);
              width: 190px;
              height: 117px;
              border-radius: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              &::after {
                position: absolute;
                content: '';
                right: var(--right);
                left: var(--left);
                top: 50%;
                width: 150px;
                height: 1px;
                background-color: var(--colors);
              }
              > div {
                @include text();
              }
            }
          }
        }
      }
      .content-warp-circle-box {
        width: 361.73px;
        height: 361.73px;
        @include alignCenter();
        display: grid;
        .content-warp-circle-box-white {
          @include alignCenter();
          width: 100%;
          height: 100%;
          border-radius: 100%;
          background-color: #fff;
        }
        .content-warp-circle-box-icon1 {
          @include alignCenter();
          z-index: 2;
          width: 361.73px;
          height: 361.73px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .content-warp-circle-box-icon2 {
          @include alignCenter();
          z-index: 3;
          width: 361.73px;
          height: 361.73px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .content-warp-circle-box-border {
          opacity: 0.3;
          @include alignCenter();
          width: 100%;
          height: 100%;
          border-radius: 100%;
          border: 4px solid var(--theme-color-1, #000);
        }
        .content-warp-circle {
          @include alignCenter();
          width: 100%;
          height: 100%;
          transform: rotate(var(--rotate));
          .content-warp-circle-item {
            @include alignCenter();
            width: 350px;
            height: 350px;

            // background-color: #000;
            .content-warp-circle-item-r {
              transform: rotate(0deg);
              position: relative;
              width: 350px;
              height: 350px;
              border-radius: 100%;
              &::before {
                z-index: 2;
                content: '';
                width: 16px;
                height: 16px;
                position: absolute;
                border-radius: 100%;
                top: -10px;
                transform: translate(-68%);
                background-color: var(--color);
              }
            }
          }
        }
      }
    }
    .content-name {
      margin-top: 50px;
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      > div {
        display: flex;
        width: 80%;
        justify-content: center;

        > div {
          margin: 0 10px;
          display: flex;
          width: 100%;
          > div:nth-child(1) {
            margin-right: 5px;
            width: 21px;
            height: 21px;
            background-color: var(--color);
          }
          > div:nth-child(2) {
            @include bottomText();
          }
        }
      }
    }
  }
}
</style>
